import { Api } from "../config/request";

export default {
  getPendingDeductionList(queryParams) {
    return Api.get(
      `/driver-accounting/pending-deduction-ledgers?${queryParams}`
    );
  },
};
